import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=b59559e0&scoped=true"
import script from "./contact.js?vue&type=script&lang=js&external"
export * from "./contact.js?vue&type=script&lang=js&external"
import style0 from "./contact.vue?vue&type=style&index=0&id=b59559e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59559e0",
  null
  
)

export default component.exports